import React, { useContext } from "react";
import styled from "styled-components";

import { Button, HSpace } from "@examspark/common-ui";
import { IconPencilLine } from "@examspark/common-ui/dist/components/icons";

import { ItemPosition } from "../../utils/sections";

import { ExamContext } from "./context/examContext";
import NavigationItem from "./NavigationItem";

const Styled = styled.div`
  --border-color: #eaeaea;
  /* border: solid 1px var(--border-color); */

  & > div {
    border-top: solid 1px var(--border-color);
  }
  & > div:first-child {
    border-top: none;
  }
`;

const NavigationSectionTitle = styled.div`
  --border-color: #eaeaea;
  background-color: var(--border-color);
  color: hsl(0, 0%, 40%);
  padding: 0.7rem 1rem;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.1rem;
`;

interface Props {
  items: any;
  flaggedItemIds?: string[];
  currentPosition: string;
  onRequestEditItem?: (itemId: ItemPosition) => void;
  onItemClick?: (
    e: React.MouseEvent<HTMLDivElement>,
    itemId: ItemPosition,
  ) => void;
}

const Navigation: React.FC<Props> = (props) => {
  const [context] = useContext(ExamContext);

  return (
    <>
      {props.items?.sections?.map?.((f: any, fIdx: number) => {
        return (
          <React.Fragment key={fIdx}>
            {/* in `by-section` mode, only render question in the current section */}
            {context.sectionNavigationMode === "linear" &&
            fIdx !== context.position.section ? null : (
              <>
                <NavigationSectionTitle>
                  Section {fIdx + 1}
                </NavigationSectionTitle>
                <Styled>
                  {f.questionIds.map((itemId: any, iIdx: number) => {
                    const pos = [0, fIdx, iIdx].join(".");
                    const currentPosition: ItemPosition = {
                      form: 0,
                      section: fIdx,
                      question: iIdx,
                    };

                    // the onscreen question number is based
                    // on the index of the question in whole exam
                    const questionNumber =
                      props.items.sections.reduce(
                        (acc: number, section: any, idx: number) => {
                          if (idx < fIdx) {
                            return acc + section.questionIds.length;
                          }
                          return acc;
                        },
                        0,
                      ) +
                      iIdx +
                      1;

                    return (
                      <NavigationItem
                        key={itemId}
                        flagged={props.flaggedItemIds?.includes(itemId)}
                        active={pos === props.currentPosition}
                        onClick={(e) => props.onItemClick?.(e, currentPosition)}
                      >
                        <HSpace style={{ flex: 1, alignItems: "center" }}>
                          <div style={{ flex: 1 }}>
                            Question {questionNumber}{" "}
                          </div>
                          {!!props.onRequestEditItem && (
                            <div style={{ margin: "-5px" }}>
                              <Button
                                title="Edit"
                                variant="plain"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  props.onRequestEditItem?.(currentPosition);
                                }}
                                icon={<IconPencilLine />}
                              />
                            </div>
                          )}
                        </HSpace>
                      </NavigationItem>
                    );
                  })}
                </Styled>
              </>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Navigation;
